import(/* webpackMode: "eager" */ "/code/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/code/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Dosis\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"dosis\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/code/src/_layout/clientWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/code/src/_layout/utils/registry.js");
